const stripeKey = {
  'key': process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY
}

export default stripeKey